import { Component} from "@angular/core";
import { CellFocusedEvent, IToolPanel, IToolPanelParams } from "ag-grid-community";
import { Command } from 'app/models/command';
import { SiteReviewService } from 'app/services/site-review.service';
@Component({
  selector: 'app-history',
  templateUrl: './history.component.html',
  styleUrls: ['./history.component.css'],
  standalone: false
})
export class HistoryComponent implements IToolPanel {

  constructor(private db: SiteReviewService) { }

  results: any[] = [];

  history = {
    column: "",
    table: "",
    keyColumn:"",
    id: 0,
    value: ""
  }

  private params: IToolPanelParams;

  agInit(params: IToolPanelParams): void {
    this.params = params;
   this.params.api.addEventListener('cellFocused', (event: CellFocusedEvent) => { 
    this.checkHistory(event);
    });
  }

  checkHistory(obj) {
    
    if (obj.column) {
      if(!obj.column.colId) return;
      if(obj.column.colId === 'ag-Grid-AutoColumn') return;

      let rowIndex = obj.rowIndex;
      
      // use id if there are specific requirements
      // console.log(obj.column);
      let column='';
      if(obj.column.colDef.id){
        column = obj.column.colDef.id
      } else if(obj.column.colId){
        column = obj.column.colId
      }
      else{
        column =  obj.column.colDef.columnName;
      }

      let table = obj.column.colDef.table;
      let row = obj.api.getDisplayedRowAtIndex(rowIndex);
      if(row?.group) return ;
      
      let value = row?.data?.[obj.column.colId];
      if(value === undefined || value === null) value = '';

      if (row?.data) {
        
        let id = row?.data?.jobID;
        if(column=='civilGeneralForeman') table='Job'
        if(column=='civilForeman') table='Job'
        if(column=='electricForeman') table='Job'
        if(column=='electricGeneralForeman')  table='Job'
        if(column=='civilActualEndDate')  table='Job'
        if(column=='electricActualEndDate')  table='Job'
        if(column=='bidStatus')  table='Job'
        if(!table || table === undefined || table === null) table='Job';

        if(table === 'JobEarning'){
          id = row?.data?.jobEarningID;
        }

        if(table === 'Tag'){
          id = row?.data?.tagID;
        }

        this.history = {
          column: column,
          table: table,
          keyColumn:table+"ID" ,
          id: id,
          value: value
        }
        this.retrieveHistory();
      }
    }
  }

  retrieveHistory() {
    // exec cmdCellHistory 'Job', 'JobID', 6189, 'Address1','AwWdHLKTC5BgBE4lPrbo';
    //@TableName varchar(50), @KeyColumn varchar(50), @KeyValue int =0, @ColumnName varchar(50)
    let obj = this.history;
    let cmd = new Command();
 
    cmd.procedure = "cmdCellHistory"
    cmd.addParameter("TableName", obj.table)
    cmd.addParameter("KeyColumn", obj.keyColumn)
    cmd.addParameter("KeyValue", obj.id)
    cmd.addParameter("ColumnName", obj.column)

    this.db.command(cmd)
      .subscribe(retval => {
        this.results = retval;
      });
  }

  updateTotals(): void {
  
    this.params.api.forEachNode(function (rowNode) {
      let data = rowNode.data;
  
    });
 
  }
  
  refresh(params: IToolPanelParams){
    this.params = params;
  }

}
